import { defineStore } from 'pinia';
import { ref } from 'vue';
import apiClient from '@/plugins/api-client';
import { getApiRoot } from '@/helpers/api';
import { getKeycloak } from '@/helpers/keycloak';
import { useI18n } from 'vue-i18n';
import { useApi } from '@/composables/useApi';

export const useOrderStore = defineStore('orderStore', () => {
  const { t } = useI18n();
  const { apiGet } = useApi();

  const order = ref(null);

  async function getOrderByID(id) {
    order.value = await apiGet(`orders/${id}`);
  }

  async function signOrderDelivery(orderID, data) {
    const headers = { Authorization: `Bearer ${(await getKeycloak()).token}` };
    const response = await apiClient.post(
      `${getApiRoot()}/orders/${orderID}/sign`,
      data,
      { headers },
    );
    if (response.status === 200) {
      return true;
    } else {
      throw new Error(response.data.message);
    }
  }

  function getOrderDocument(order) {
    return {
      name: 'order',
      downloading: false,
      cdn: false,
      text: t('orderDetail.order'),
      downloadName: `${t('orderDetail.order')}-${order.id}.pdf`,
      url: `orders/${order.id}/files/${order.offerTypeId}?type=print`,
    };
  }

  return {
    order,
    getOrderByID,
    signOrderDelivery,
    getOrderDocument,
  };
});
